import React from 'react';
import { ProgressCircle } from '@americanexpress/dls-react';

function Spinner() {
  return (
    <section className="pad-4-b pad-4-t">
      <div id="spinner" className="pad-4-t pad-4-b flex flex-justify-center flex-align-items-center">
        <ProgressCircle size="lg" />
      </div>
    </section>
  );
}

export default Spinner;
